import React, { useEffect } from "react";
import HeaderNav from "./common/HeaderNav";
import Footer from "./Footer";
import privacy from "../images/privacy.png";

function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title =
      "Privacy Policy | Trusted Provider of Premium Mobile Numbers Since 2010";
    document
      .querySelector("meta[name='description']")
      .setAttribute(
        "content",
        "Learn about VIP Number Studio, a trusted provider of premium mobile numbers across India since 2010. Discover our commitment to delivering over 10,000 exclusive numbers and our dedication to customer satisfaction."
      );
  }, []);

  return (
    <>
      <HeaderNav />
      <div
        style={{
          position: "relative",
          width: "100%",
          height: "300px",
          overflow: "hidden",
          marginTop: "60px",
        }}
      >
        {/* Background Image */}
        <div
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            backgroundImage: `url(${privacy})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        ></div>

        {/* Gradient Overlay */}
        <div
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            background: "#000040",
          }}
        ></div>
        {/* Red circular accent */}
        <div
          style={{
            position: "absolute",
            width: "300px",
            height: "300px",
            backgroundColor: "rgba(255, 0, 0, 0.8)",
            borderRadius: "50%",
            top: "-150px",
            right: "-100px",
            zIndex: 1,
          }}
        ></div>

        {/* Second red circular accent */}
        <div
          style={{
            position: "absolute",
            width: "150px",
            height: "150px",
            backgroundColor: "rgba(255, 0, 0, 0.8)",
            borderRadius: "50%",
            bottom: "-70px",
            left: "50px",
            zIndex: 1,
          }}
        ></div>

        {/* Decorative dots */}
        <div
          style={{
            position: "absolute",
            top: "20px",
            left: "20px",
            display: "flex",
            gap: "5px",
          }}
        >
          <div
            style={{
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              backgroundColor: "rgba(255, 255, 255, 0.7)",
            }}
          ></div>
          <div
            style={{
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              backgroundColor: "rgba(255, 255, 255, 0.7)",
            }}
          ></div>
          <div
            style={{
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              backgroundColor: "rgba(255, 255, 255, 0.7)",
            }}
          ></div>
        </div>

        {/* Decorative triangle */}
        <div
          style={{
            position: "absolute",
            bottom: "15px",
            right: "60px",
            width: 0,
            height: 0,
            borderLeft: "15px solid transparent",
            borderRight: "15px solid transparent",
            borderBottom: "26px solid rgba(255, 255, 255, 0.15)",
            transform: "rotate(45deg)",
          }}
        ></div>

        {/* Content Container */}
        <div
          style={{
            position: "relative",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            padding: "0 20px",
            zIndex: "2",
          }}
        >
          <h1
            style={{
              color: "white",
              fontSize: "42px",
              fontWeight: "800",
              marginBottom: "16px",
              textAlign: "center",
              textShadow: "2px 2px 8px rgba(0, 0, 0, 0.6)",
            }}
          >
            Privacy Policy
          </h1>

          <p
            style={{
              color: "white",
              fontSize: "18px",
              fontWeight: "400",
              maxWidth: "700px",
              textAlign: "center",
              textShadow: "1px 1px 4px rgba(0, 0, 0, 0.8)",
            }}
          >
            Your data security and privacy are our top priorities
          </p>

          {/* Decorative Line */}
          <div
            style={{
              width: "80px",
              height: "4px",
              background:
                "linear-gradient(90deg,rgba(255, 255, 255, 0.74), rgb(233, 2, 2))",
              marginTop: "20px",
              borderRadius: "2px",
            }}
          ></div>
        </div>
      </div>
      <div className="terms">
        <div className="container">
          <div className="row">
            <div className="titlex">
              <h1 className="policy-header">Privacy Policy</h1>
            </div>
            <div className="contentx">
              <p className="headingx text-muted">
                Last updated on {new Date().getFullYear()}
              </p>
              <p className="para1">
                This privacy policy sets out how MODERN TELECOM SALES AND
                SERVICES uses and protects any information that you give MODERN
                TELECOM SALES AND SERVICES when you use this website.
              </p>
              <p className="para2">
                MODERN TELECOM SALES AND SERVICES is committed to ensuring that
                your privacy is protected. Should we ask you to provide certain
                information by which you can be identified when using this
                website, and then you can be assured that it will only be used
                in accordance with this privacy statement.
              </p>
              <p className="heading1">
                <h6>We may collect the following information:</h6>
              </p>
              <p className="lists">
                <ul>
                  <li className="list-content">Name and job title</li>
                  <li className="list-content">
                    Contact information including email address
                  </li>
                  <li className="list-content">
                    Demographic information such as postcode, preferences and
                    interests
                  </li>
                  <li className="list-content">
                    Other information relevant to customer surveys and/or offers
                  </li>
                </ul>
              </p>
              <p className="heading1">
                <h6>What we do with the information we gather</h6>
              </p>
              <p className="para3">
                We require this information to understand your needs and provide
                you with a better service, and in particular for the following
                reasons:
              </p>
              <p className="lists">
                <ul>
                  <li className="list-content">Internal record keeping.</li>
                  <li className="list-content">
                    We may use the information to improve our products and
                    services.
                  </li>
                  <li className="list-content">
                    We may periodically send promotional emails about new
                    products, special offers or other information which we think
                    you may find interesting using the email address which you
                    have provided.
                  </li>
                  <li className="list-content">
                    From time to time, we may also use your information to
                    contact you for market research purposes. We may contact you
                    by email, phone, fax or mail. We may use the information to
                    customize the website according to your interests.
                  </li>
                </ul>
              </p>
              <p className="para4">
                We are committed to ensuring that your information is secure. In
                order to prevent unauthorized access or disclosure we have put
                in suitable measures.
              </p>
              <p className="heading1">
                <h6>How we use cookies</h6>
              </p>
              <p className="para5">
                A cookie is a small file which asks permission to be placed on
                your computer's hard drive. Once you agree, the file is added
                and the cookie helps analyses web traffic or lets you know when
                you visit a particular site. Cookies allow web applications to
                respond to you as an individual. The web application can tailor
                its operations to your needs, likes and dislikes by gathering
                and remembering information about your preferences.
              </p>
              <p className="para5">
                We use traffic log cookies to identify which pages are being
                used. This helps us analyses data about webpage traffic and
                improve our website in order to tailor it to customer needs. We
                only use this information for statistical analysis purposes and
                then the data is removed from the system.
              </p>
              <p className="para6">
                Overall, cookies help us provide you with a better website, by
                enabling us to monitor which pages you find useful and which you
                do not. A cookie in no way gives us access to your computer or
                any information about you, other than the data you choose to
                share with us.
              </p>
              <p className="para7">
                You can choose to accept or decline cookies. Most web browsers
                automatically accept cookies, but you can usually modify your
                browser setting to decline cookies if you prefer. This may
                prevent you from taking full advantage of the website.
              </p>
              <p className="heading1">
                <h6>Controlling your personal information</h6>
              </p>
              <p className="para7">
                You may choose to restrict the collection or use of your
                personal information in the following ways:
              </p>
              <p className="lists">
                <ul>
                  <li className="list-content">
                    Whenever you are asked to fill in a form on the website,
                    look for the box that you can click to indicate that you do
                    not want the information to be used by anybody for direct
                    marketing purposes
                  </li>
                  <li className="list-content">
                    If you have previously agreed to us using your personal
                    information for direct marketing purposes, you may change
                    your mind at any time by writing to or emailing us at
                    sales@vipnumberstudio.com
                  </li>
                </ul>
              </p>
              <p className="para8">
                We will not sell, distribute or lease your personal information
                to third parties unless we have your permission or are required
                by law to do so. We may use your personal information to send
                you promotional information about third parties which we think
                you may find interesting if you tell us that you wish this to
                happen.
              </p>
              <p className="para8">
                If you believe that any information we are holding on you is
                incorrect or incomplete, please write to or email us as soon as
                possible, at the above address. We will promptly correct any
                information found to be incorrect.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default PrivacyPolicy;
